import styled from 'styled-components';
import { flexbox } from '../../styles/helpers/flexbox';
import ThemeHelper from '../../themes/theme-helper';

const HelpWrapper = styled.div(() => `
   ${flexbox()};
   
   color: #C53B04;
   width: 100%;
   padding: 5px 1px 1px 8px;
   
   path {
    fill: #C53B04 !important;
   }
   
   .heading {
     width: 88%;
   }
   
   .arrow {
     cursor: pointer;
   }
`);

const StudentListWrapper = styled.div((props) => {
  const { colours } = ThemeHelper.getTheme(props);

  return `
     color: #C53B04;
     width: 100%;
     overflow: auto;
     padding: 5px 0px 0px 25px;
     
     .list {
       height: 24px;
       line-height: 16px;
       list-style-type: square;
     }

     border-bottom: 1px solid ${colours.grey[400]};
`;
});

export { HelpWrapper, StudentListWrapper };
